// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36d65e20","455":"1c82171c"}[chunkId] + ".chunk.js";
};